// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sk9l","left":"styles_left__1E_ze"};